import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ListItem } from '../../flayr-components/ListItem/ListItem';
import ArrayMap from '../ArrayMap/ArrayMap';
import Icon from '../Icon/Icon';

interface ICheckListProps {
  items?: Array<
    { title: React.ReactNode; subTitle?: React.ReactNode } | string
  >;
  titleClassName?: string;
  subTitleClassName?: string;
  title?: React.ReactNode;
  hideIcon?: boolean;
}

const CheckList: React.FC<React.PropsWithChildren<ICheckListProps>> = ({
  items = [],
  titleClassName = '',
  subTitleClassName = '',
  title,
  hideIcon,
}) => {
  return (
    <ul className="space-y-3">
      {title}
      <ArrayMap items={items}>
        {(item) => {
          if (typeof item === 'string') {
            item = { title: item };
          }
          return (
            <ListItem
              leftIcon={!hideIcon && <FontAwesomeIcon icon={faCheck} />}
              leftIconClassName="text-green-500 self-start pt-1 text-xl"
              title={item.title}
              titleClassName={`font-medium ${titleClassName}`}
              subTitle={item.subTitle || ''}
              subTitleClassName={`text-sm text-gray-600 ${subTitleClassName}`}
              rightIcon={null}
            />
          );
        }}
      </ArrayMap>
    </ul>
  );
};
export default CheckList;
